import { render, staticRenderFns } from "./PlayerPositionButtons.vue?vue&type=template&id=3b6afa10"
import script from "./PlayerPositionButtons.vue?vue&type=script&lang=js"
export * from "./PlayerPositionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports